export enum AgentJurisdictionColorEnum {
    Free = "DarkGray",
    In = "DarkGreen",
    Out = "DarkBlue",
    Unset = "Red"
}